export default "__VITE_PUBLIC_ASSET__677c0005__"